


import { CheckOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import Footer from '../../../../components/common/Footer';
import PageHeading from '../../../../components/common/PageHeading';
import RightBar from '../../../../components/common/RightBar';
import RightBarMethod from '../../../../components/common/RightBar/RightBarMethod';
import './OwnerACH.css'

const OwnerACHRightBar = [

    RightBarMethod(" LETTERS", "t2", <i className="fa-solid fa-file-lines"></i>, [
        RightBarMethod("Owner Bank Account Information", "8", "", "", "/"),

    ]),
];
const columns = [
    {
        title: <p className="bold-name">Name</p>,
        dataIndex: 'name',
        render: (text) => <span className="onclick-text">{text}</span>,

    },
    {
        title: <p className="bold-name">Paid By ACH</p>,
        dataIndex: 'isPaidByACH',
        render: (isPaidByACH) => {
            return isPaidByACH ? (
                <CheckOutlined
                    style={{ fontSize: '16px', fontWeight: 'bolder', color: 'green' }} />
            ) : " "
        }
    },
    {
        title: <p className="bold-name">Routing Number</p>,
        dataIndex: 'Routing_Number',

    },
    {
        title: <p className="bold-name">Account Number</p>,
        dataIndex: 'Account_Number',

    },
    {
        title: <p className="bold-name">Account Type</p>,
        dataIndex: 'Account_type',

    }];
const data = [
    {
        key: '1',
        name: 'Aspire Premier Properties',
        isPaidByACH: true,
        Routing_Number: '0572098909',
        Account_Number: 'XXXXXXXXX',
        Account_type: 'Checking',
    },
    {
        key: '2',
        name: 'Bethany Townhomes LLC',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '3',
        name: 'Casa Rentals LLC',
        isPaidByACH: false,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '4',
        name: 'sb, Khan',
        isPaidByACH: true,
        Routing_Number: '',
        Account_Number: '',
        Account_type: '',
    },
    {
        key: '5',
        name: 'Sitafa and Jevon Gill',
        isPaidByACH: true,
        Routing_Number: '2372098909',
        Account_Number: 'XXXXXXXXXXXXXX',
        Account_type: 'Checking'
    },
];
const OwnerACH = () =>
    <>
        <PageHeading heading="Owner ACH Setup" />
        <Table
            columns={columns}
            dataSource={data}
            pagination={false}
        //  rowClassName={(record, index) => index % 2 === 0 ? 'gray-row' : 'white-row'}
        //TODO: Isko dekhen
        />

        <div>
        </div>
        <div className="RightSidebar">
            <RightBar RightBarData={OwnerACHRightBar} />
        </div>
    </>

export default OwnerACH;